/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateUserResponseDto,
  CompleteOnboardingUserRequestDto,
  GetMeParams,
  GetMeResponseDto,
  GetProfilePictureUploadUrlRequest,
  GetProfilePictureUploadUrlResponseDto,
  GetUserListPaginatedParams,
  GetUserListPaginatedResponseDto,
  InviteUserRequestDto,
  UpdateUserLanguageDto,
  UpdateUserNotificationsPreferencesDto,
  UpdateUserProfileRequestDto,
  UpdateUserRequestDto,
  UserId
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get current user information
 */
export const getMe = (
    params?: GetMeParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetMeResponseDto>(
      {url: `/users/me`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMeQueryKey = (params?: GetMeParams,) => {
    return [`/users/me`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = null>(params?: GetMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = null


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params: undefined |  GetMeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params?: GetMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params?: GetMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user information
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params?: GetMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = null>(params?: GetMeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeSuspenseQueryError = null


export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params: undefined |  GetMeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params?: GetMeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params?: GetMeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user information
 */

export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = null>(
 params?: GetMeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Invite user to an organization
 */
export const inviteUser = (
    inviteUserRequestDto: InviteUserRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/users/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteUserRequestDto, signal
    },
      options);
    }
  


export const getInviteUserMutationOptions = <TError = null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: InviteUserRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: InviteUserRequestDto}, TContext> => {

const mutationKey = ['inviteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUser>>, {data: InviteUserRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  inviteUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
    export type InviteUserMutationBody = InviteUserRequestDto
    export type InviteUserMutationError = null

    /**
 * @summary Invite user to an organization
 */
export const useInviteUser = <TError = null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{data: InviteUserRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteUser>>,
        TError,
        {data: InviteUserRequestDto},
        TContext
      > => {

      const mutationOptions = getInviteUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Complete user onboarding process
 */
export const completeOnboarding = (
    completeOnboardingUserRequestDto: CompleteOnboardingUserRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/users/me/onboarding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeOnboardingUserRequestDto, signal
    },
      options);
    }
  


export const getCompleteOnboardingMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboarding>>, TError,{data: CompleteOnboardingUserRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeOnboarding>>, TError,{data: CompleteOnboardingUserRequestDto}, TContext> => {

const mutationKey = ['completeOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeOnboarding>>, {data: CompleteOnboardingUserRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  completeOnboarding(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof completeOnboarding>>>
    export type CompleteOnboardingMutationBody = CompleteOnboardingUserRequestDto
    export type CompleteOnboardingMutationError = null | null

    /**
 * @summary Complete user onboarding process
 */
export const useCompleteOnboarding = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboarding>>, TError,{data: CompleteOnboardingUserRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeOnboarding>>,
        TError,
        {data: CompleteOnboardingUserRequestDto},
        TContext
      > => {

      const mutationOptions = getCompleteOnboardingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get profile picture upload URL
 */
export const getProfilePictureUploadUrl = (
    getProfilePictureUploadUrlRequest: GetProfilePictureUploadUrlRequest,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetProfilePictureUploadUrlResponseDto>(
      {url: `/users/me/profile-picture-upload-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getProfilePictureUploadUrlRequest, signal
    },
      options);
    }
  


export const getGetProfilePictureUploadUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProfilePictureUploadUrl>>, TError,{data: GetProfilePictureUploadUrlRequest}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getProfilePictureUploadUrl>>, TError,{data: GetProfilePictureUploadUrlRequest}, TContext> => {

const mutationKey = ['getProfilePictureUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProfilePictureUploadUrl>>, {data: GetProfilePictureUploadUrlRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProfilePictureUploadUrl(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProfilePictureUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof getProfilePictureUploadUrl>>>
    export type GetProfilePictureUploadUrlMutationBody = GetProfilePictureUploadUrlRequest
    export type GetProfilePictureUploadUrlMutationError = unknown

    /**
 * @summary Get profile picture upload URL
 */
export const useGetProfilePictureUploadUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProfilePictureUploadUrl>>, TError,{data: GetProfilePictureUploadUrlRequest}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProfilePictureUploadUrl>>,
        TError,
        {data: GetProfilePictureUploadUrlRequest},
        TContext
      > => {

      const mutationOptions = getGetProfilePictureUploadUrlMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Activate user
 */
export const activeUser = (
    id: UserId,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ActivateUserResponseDto>(
      {url: `/users/${id}/activate`, method: 'POST', signal
    },
      options);
    }
  


export const getActiveUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activeUser>>, TError,{id: UserId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activeUser>>, TError,{id: UserId}, TContext> => {

const mutationKey = ['activeUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activeUser>>, {id: UserId}> = (props) => {
          const {id} = props ?? {};

          return  activeUser(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActiveUserMutationResult = NonNullable<Awaited<ReturnType<typeof activeUser>>>
    
    export type ActiveUserMutationError = unknown

    /**
 * @summary Activate user
 */
export const useActiveUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activeUser>>, TError,{id: UserId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activeUser>>,
        TError,
        {id: UserId},
        TContext
      > => {

      const mutationOptions = getActiveUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Deactivate user
 */
export const deactivateUser = (
    id: UserId,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<ActivateUserResponseDto>(
      {url: `/users/${id}/deactivate`, method: 'POST', signal
    },
      options);
    }
  


export const getDeactivateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: UserId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: UserId}, TContext> => {

const mutationKey = ['deactivateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateUser>>, {id: UserId}> = (props) => {
          const {id} = props ?? {};

          return  deactivateUser(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateUserMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateUser>>>
    
    export type DeactivateUserMutationError = unknown

    /**
 * @summary Deactivate user
 */
export const useDeactivateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateUser>>, TError,{id: UserId}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateUser>>,
        TError,
        {id: UserId},
        TContext
      > => {

      const mutationOptions = getDeactivateUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update user profile
 */
export const UsersController_updateProfile = (
    updateUserProfileRequestDto: UpdateUserProfileRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/users/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserProfileRequestDto
    },
      options);
    }
  


export const getUsersControllerUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof UsersController_updateProfile>>, TError,{data: UpdateUserProfileRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof UsersController_updateProfile>>, TError,{data: UpdateUserProfileRequestDto}, TContext> => {

const mutationKey = ['usersControllerUpdateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof UsersController_updateProfile>>, {data: UpdateUserProfileRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  UsersController_updateProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersControllerUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof UsersController_updateProfile>>>
    export type UsersControllerUpdateProfileMutationBody = UpdateUserProfileRequestDto
    export type UsersControllerUpdateProfileMutationError = unknown

    /**
 * @summary Update user profile
 */
export const useUsersControllerUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof UsersController_updateProfile>>, TError,{data: UpdateUserProfileRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof UsersController_updateProfile>>,
        TError,
        {data: UpdateUserProfileRequestDto},
        TContext
      > => {

      const mutationOptions = getUsersControllerUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update user's details
 */
export const updateUser = (
    id: UserId,
    updateUserRequestDto: UpdateUserRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequestDto
    },
      options);
    }
  


export const getUpdateUserMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: UserId;data: UpdateUserRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: UserId;data: UpdateUserRequestDto}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: UserId;data: UpdateUserRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserRequestDto
    export type UpdateUserMutationError = null | null

    /**
 * @summary Update user's details
 */
export const useUpdateUser = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: UserId;data: UpdateUserRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: UserId;data: UpdateUserRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get users of the organization
 */
export const getUserListPaginated = (
    params: GetUserListPaginatedParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserListPaginatedResponseDto>(
      {url: `/users`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserListPaginatedQueryKey = (params?: GetUserListPaginatedParams,) => {
    return [`/users`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserListPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getUserListPaginated>>, TError = null | null | null>(params: GetUserListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserListPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserListPaginated>>> = ({ signal }) => getUserListPaginated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserListPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserListPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserListPaginated>>>
export type GetUserListPaginatedQueryError = null | null | null


export function useGetUserListPaginated<TData = Awaited<ReturnType<typeof getUserListPaginated>>, TError = null | null | null>(
 params: GetUserListPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserListPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getUserListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserListPaginated<TData = Awaited<ReturnType<typeof getUserListPaginated>>, TError = null | null | null>(
 params: GetUserListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserListPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getUserListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserListPaginated<TData = Awaited<ReturnType<typeof getUserListPaginated>>, TError = null | null | null>(
 params: GetUserListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get users of the organization
 */

export function useGetUserListPaginated<TData = Awaited<ReturnType<typeof getUserListPaginated>>, TError = null | null | null>(
 params: GetUserListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserListPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update user's notifications preferences
 */
export const updateUserNotificationsPreferences = (
    updateUserNotificationsPreferencesDto: UpdateUserNotificationsPreferencesDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/users/notifications_preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserNotificationsPreferencesDto
    },
      options);
    }
  


export const getUpdateUserNotificationsPreferencesMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserNotificationsPreferences>>, TError,{data: UpdateUserNotificationsPreferencesDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserNotificationsPreferences>>, TError,{data: UpdateUserNotificationsPreferencesDto}, TContext> => {

const mutationKey = ['updateUserNotificationsPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserNotificationsPreferences>>, {data: UpdateUserNotificationsPreferencesDto}> = (props) => {
          const {data} = props ?? {};

          return  updateUserNotificationsPreferences(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserNotificationsPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserNotificationsPreferences>>>
    export type UpdateUserNotificationsPreferencesMutationBody = UpdateUserNotificationsPreferencesDto
    export type UpdateUserNotificationsPreferencesMutationError = null | null

    /**
 * @summary Update user's notifications preferences
 */
export const useUpdateUserNotificationsPreferences = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserNotificationsPreferences>>, TError,{data: UpdateUserNotificationsPreferencesDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserNotificationsPreferences>>,
        TError,
        {data: UpdateUserNotificationsPreferencesDto},
        TContext
      > => {

      const mutationOptions = getUpdateUserNotificationsPreferencesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update user's preferred language
 */
export const updateUserLanguage = (
    updateUserLanguageDto: UpdateUserLanguageDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/users/profile/language`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserLanguageDto
    },
      options);
    }
  


export const getUpdateUserLanguageMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserLanguage>>, TError,{data: UpdateUserLanguageDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserLanguage>>, TError,{data: UpdateUserLanguageDto}, TContext> => {

const mutationKey = ['updateUserLanguage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserLanguage>>, {data: UpdateUserLanguageDto}> = (props) => {
          const {data} = props ?? {};

          return  updateUserLanguage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserLanguage>>>
    export type UpdateUserLanguageMutationBody = UpdateUserLanguageDto
    export type UpdateUserLanguageMutationError = null | null

    /**
 * @summary Update user's preferred language
 */
export const useUpdateUserLanguage = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserLanguage>>, TError,{data: UpdateUserLanguageDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserLanguage>>,
        TError,
        {data: UpdateUserLanguageDto},
        TContext
      > => {

      const mutationOptions = getUpdateUserLanguageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    